import type { ReactNode, RefObject } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { TEST_ID } from '@/src/general/constants/testId'

type TAccessibilitySkippedMenuProps = {
  refToMainContent: RefObject<View | null>
  refToNavigation: RefObject<View | null>
  refToMenu: RefObject<View | null>
  refsState: Record<'main' | 'navigation' | 'menu', boolean>
}

export const AccessibilitySkippedMenu = ({
  refToMainContent,
  refToNavigation,
  refToMenu,
  refsState,
}: TAccessibilitySkippedMenuProps): ReactNode => {
  const customClassName =
    'sr-only data-[focus-visible=true]:not-sr-only data-[focus-visible=true]:w-full data-[focus-visible=true]:rounded-none'

  return (
    <View className="absolute z-50 m-6">
      {refsState.main && (
        <Button
          colors="primary"
          variant="faded"
          shadow="sm"
          onPress={() => refToMainContent.current?.focus()}
          testID={TEST_ID.ACCESSIBILITY_MENU.MAIN_BUTTON}
          className={customClassName}
        >
          <FormattedMessage id="app.avoidance-navigation.content" />
        </Button>
      )}
      {refsState.navigation && (
        <Button
          colors="primary"
          variant="faded"
          shadow="sm"
          onPress={() => refToNavigation.current?.focus()}
          testID={TEST_ID.ACCESSIBILITY_MENU.NAVIGATION_BUTTON}
          className={customClassName}
        >
          {/* TODO: Change text */}
          <FormattedMessage id="app.navigation.main" />
        </Button>
      )}
      {refsState.menu && (
        <Button
          colors="primary"
          variant="faded"
          shadow="sm"
          onPress={() => refToMenu.current?.focus()}
          className={customClassName}
          testID={TEST_ID.ACCESSIBILITY_MENU.MENU_BUTTON}
        >
          {/* TODO: Change text */}
          <FormattedMessage id="app.navigation.secondary" />
        </Button>
      )}
    </View>
  )
}
